// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3fkha","alertIcon":"ConfirmModal_alertIcon__CsG_h"};